import { Button, DialogActions } from '@mui/material';
import type { ReactNode } from 'react';

type DialogActionBarProps = {
  cancelLabel?: string;
  commitLabel: string;
  onCancel: () => void;
  onCommit: () => void;
  commitDisabled?: boolean;
  cancelDisabled?: boolean;
  committing?: boolean;
  destructiveAction?: ReactNode;
};

export function DialogActionBar({
  cancelLabel = 'Cancel',
  commitLabel,
  onCancel,
  onCommit,
  commitDisabled = false,
  cancelDisabled = false,
  committing = false,
  destructiveAction,
}: DialogActionBarProps) {
  return (
    <DialogActions sx={{ gap: 1, justifyContent: destructiveAction ? 'space-between' : 'flex-end', flexWrap: 'wrap' }}>
      {destructiveAction}
      <span>
        <Button onClick={onCancel} disabled={cancelDisabled || committing}>
          {cancelLabel}
        </Button>
        <Button variant="contained" onClick={onCommit} disabled={commitDisabled || committing}>
          {commitLabel}
        </Button>
      </span>
    </DialogActions>
  );
}

